export default __webpack_public_path__ + "static/media/balance.ca3c8dcb.jpg";